










































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Emit, InjectReactive, Watch } from 'vue-property-decorator';
import colors from 'vuetify/es5/util/colors';
import { inject } from 'inversify-props';
import ClientModel from '@/models/crm/client.model';
import { ClientStatusEnum } from '@/enums/crm/client-status.enum';
import { StringHelper } from '@/utils/helpers/string-helper';
import CrmChatCallerButton from '@/components/crm/chat-caller-button.vue';
import ContentDialog from '@/components/content-dialog.vue';
import { ClientTypeEnum } from '@/enums/client-type.enum';
import { OrigemTypeEnum } from '@/enums/origin-register-type.enum';
import SettingsModel from '@/models/crm/settings.model';
import ResponsibleAttendantModel from '@/models/crm/responsible-attendant.model';
import RouterService from '@/services/router.service';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import SessionService from '@/services/session.service';
import ClientManagementModel from '@/models/crm/client-management.model';
import { ClientManagerSituationEnum } from '@/enums/crm/client-manager-situation-enum';
import ContactModel from '@/models/crm/contact.model';
import ContactTypeModel from '@/models/crm/contact-type.model';
import ConfigUsuarioService from '@/services/crm/config-usuario.service';
import ContactService from '@/services/crm/contact.service';
import UserContactInfo from '@/models/crm/user-contact-info.model';

interface IChipParam {
  id: string;
  text?: string;
  htmlContent?: string;
  icon: string;
  color: string;
}

@Component({
  components: {
    CrmChatCallerButton,
    ContentDialog,
  },
})
export default class CrmClientDetailsCard extends Vue {
  @inject(InjectionIdEnum.RouterService)
  private routerService!: RouterService;

  @inject(InjectionIdEnum.SessionService)
  private sessionService!: SessionService;

  @inject(InjectionIdEnum.CrmConfigUsuarioService)
  private configUsuarioService!: ConfigUsuarioService;

  @inject(InjectionIdEnum.CrmContactService)
  private contactService!: ContactService;

  @InjectReactive('userContactInfo') readonly userContactInfo!: UserContactInfo;

  private localUserContactInfo: UserContactInfo | null = null;

  @Prop({ required: true })
  readonly client!: ClientModel;

  @Prop({ required: true })
  readonly clientType!: ClientTypeEnum;

  @Prop({ required: true })
  readonly origemType!: OrigemTypeEnum;

  @Prop()
  readonly settings!: SettingsModel;

  @Prop()
  readonly actionsLoading!: boolean;

  @Prop()
  readonly allClientManagements!: ClientManagementModel[];

  @Prop()
  readonly attendantsList!: ResponsibleAttendantModel[];

  @Prop()
  readonly clientNotIntegrated?: boolean;

  @Prop({ default: false })
  readonly disabled!: boolean;

  @Prop()
  readonly mainContactInfo!: ContactModel;

  emailAddressee!: string;

  particularitiesExpanded = false;

  viewSettingsExpanded = false;

  expandParticularitiesToDefault = false;

  private lastConfigChangeTime = 0;

  private configChangeThrottleMs = 5000;

  private isChangingConfig = false;

  private cooldownTimer: number | null = null;

  private forceReactiveUpdate = 0;

  async created(): Promise<void> {
    await this.initializeUserContext();
    await this.loadExpandirParticularidadeConfig();
  }

  async mounted(): Promise<void> {
    if (!this.currentUserContactInfo) {
      await this.initializeUserContext();
      await this.loadExpandirParticularidadeConfig();
    }
  }

  beforeDestroy(): void {
    this.stopCooldownTimer();
  }

  @Watch('client.particularidades')
  onParticularitiesToChange(): void {
    this.forceReactiveUpdate += 1;
  }

  get currentUserContactInfo(): UserContactInfo | null {
    return this.userContactInfo || this.localUserContactInfo;
  }

  get isCheckboxDisabled(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.forceReactiveUpdate;

    if (this.isChangingConfig) return true;

    const now = Date.now();
    const timeSinceLastChange = now - this.lastConfigChangeTime;
    return timeSinceLastChange < this.configChangeThrottleMs;
  }

  get remainingCooldownTime(): number {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.forceReactiveUpdate;

    const now = Date.now();
    const timeSinceLastChange = now - this.lastConfigChangeTime;
    const remaining = this.configChangeThrottleMs - timeSinceLastChange;
    return Math.max(0, Math.ceil(remaining / 1000));
  }

  private startCooldownTimer(): void {
    if (this.cooldownTimer) {
      clearInterval(this.cooldownTimer);
    }

    this.cooldownTimer = window.setInterval(() => {
      this.forceReactiveUpdate += 1;

      if (!this.isCheckboxDisabled) {
        this.stopCooldownTimer();
      }
    }, 1000);
  }

  private stopCooldownTimer(): void {
    if (this.cooldownTimer) {
      clearInterval(this.cooldownTimer);
      this.cooldownTimer = null;
    }
  }

  managementExpansionPanel: number | null = null;

  dialogConfig = {
    particularities: {
      show: false,
      editing: false,
      saving: false,
      description: '',
    },
  };

  @Emit('send-email:click')
  onSendEmail(email: string): string {
    this.emailAddressee = email;
    return this.emailAddressee;
  }

  @Emit('edit-prospect')
  onEditProspect(): ClientModel {
    return this.client;
  }

  @Emit('delete-prospect')
  onDeleteProspect(): ClientModel {
    return this.client;
  }

  @Emit('transforme-prospect')
  onTransformProspect(): ClientModel {
    return this.client;
  }

  @Emit('open-particularities')
  onOpenParticularities(): ClientModel {
    return this.client;
  }

  @Emit('edit-particularities')
  onEditParticularities(): ClientModel {
    return this.client;
  }

  @Emit('set-responsible')
  // eslint-disable-next-line class-methods-use-this
  onSetResponsibleAttendant(responsibleAttendant: number): number | null {
    // @ts-expect-error TS não estava permitindo o acesso à chamada do evento;
    this.$refs.responsibleAttendantSelect.blur();
    return responsibleAttendant;
  }

  @Emit('integrate-client')
  onIntegrateClient(): ClientModel {
    return this.client;
  }

  onOpenParticularitiesToEdit(): void {
    this.dialogConfig.particularities.description = this.client.particularidades || '';
    this.dialogConfig.particularities.editing = true;
    this.dialogConfig.particularities.show = true;
  }

  onCloseParticularities(): void {
    if (this.dialogConfig.particularities.editing && !this.dialogConfig.particularities.saving) {
      this.dialogConfig.particularities.description = this.client.particularidades || '';
    }
    this.dialogConfig.particularities.editing = false;
    this.dialogConfig.particularities.show = false;
    this.dialogConfig.particularities.saving = false;
  }

  public closeParticularitiesToSave(): void {
    this.dialogConfig.particularities.editing = false;
    this.dialogConfig.particularities.show = false;
    this.dialogConfig.particularities.saving = false;
  }

  public updateParticularitiesToLocal(newValue: string): void {
    this.updateLocalParticularities(newValue);
    this.$forceUpdate();
  }

  public updateParticularitiesToSave(newValue: string): void {
    this.client.particularidades = newValue;
    this.dialogConfig.particularities.description = newValue;
    this.$forceUpdate();
  }

  @Emit('save-particularities')
  onSaveParticularities(): { client: ClientModel; description: string } {
    this.dialogConfig.particularities.saving = true;

    this.updateLocalParticularities(this.dialogConfig.particularities.description);

    return {
      client: this.client,
      description: this.dialogConfig.particularities.description,
    };
  }

  @Emit('update-particularities')
  updateLocalParticularities(description: string): { client: ClientModel; description: string } {
    this.client.particularidades = description;

    return {
      client: this.client,
      description,
    };
  }

  clearCardFocus(): void {
    const particularitiesCard = this.$refs.particularitiesCard as Vue;
    if (particularitiesCard && particularitiesCard.$el) {
      const cardElement = particularitiesCard.$el as HTMLElement;
      cardElement.blur();

      cardElement.classList.remove('v-card--hover');
      cardElement.classList.remove('v-card--link');

      cardElement.style.removeProperty('background-color');
      cardElement.style.removeProperty('box-shadow');
    }

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  toggleViewSettings(): void {
    this.viewSettingsExpanded = !this.viewSettingsExpanded;
  }

  toggleParticularities(): void {
    this.particularitiesExpanded = !this.particularitiesExpanded;

    this.clearCardFocus();

    setTimeout(() => {
      this.clearCardFocus();

      const particularitiesCard = this.$refs.particularitiesCard as Vue;
      if (particularitiesCard && particularitiesCard.$el) {
        const cardElement = particularitiesCard.$el as HTMLElement;

        const classesToRemove = [
          'v-card--hover',
          'v-card--link',
          'v-card--outlined',
          'elevation-2',
          'elevation-4',
        ];

        classesToRemove.forEach((cls) => {
          cardElement.classList.remove(cls);
        });

        cardElement.style.backgroundColor = '#f8f9fa';
        cardElement.style.boxShadow = 'none';
        cardElement.style.outline = 'none';
      }
    }, 300);
  }

  redirectToClientPage(): void {
    this.sessionService.clientType = ClientTypeEnum.Client;
    this.sessionService.activeClient = this.client;
    this.sessionService.activeClient.type = ClientTypeEnum.Client;
    this.routerService.navigate({
      name: 'CrmDashboard',
      params: {
        clientId: this.client.cnpjCpf,
      },
      query: { clientType: ClientTypeEnum.Client },
    });
  }

  getManagementName(chip: IChipParam): string {
    const managementId = chip.id.replace('mng-', '');

    if (this.allClientManagements && Array.isArray(this.allClientManagements)) {
      const management = this.allClientManagements.find(
        (m, index) => m.collectionId?.toString() === managementId || index.toString() === managementId,
      );

      if (management && management.managementName) {
        return management.managementName;
      }
    }

    return chip.text || '';
  }

  getFinancialTitle(chip: IChipParam): string {
    if (chip.id === 'financial-creditLimit') {
      return this.$t('crm.view.financialInformation.card.creditLimit') as string;
    }
    if (chip.id === 'financial-economicGroup') {
      return 'Grupo Econômico';
    }
    return 'Informação Financeira';
  }

  getFinancialStatus(chip: IChipParam): string {
    if (chip.id === 'financial-creditLimit') {
      return this.client.limiteCredito && this.client.limiteCredito > 0 ? 'POSITIVO' : 'LIMITADO';
    }
    if (chip.id === 'financial-economicGroup') {
      return 'ATIVO';
    }
    return 'ATIVO';
  }

  getFinancialValue(chip: IChipParam): string {
    if (chip.id === 'financial-creditLimit') {
      return this.$n(this.client.limiteCredito || 0, 'currency');
    }
    if (chip.id === 'financial-economicGroup') {
      return this.client.nomeGrupoEconomico || '';
    }
    return '';
  }

  get hasParticularities(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.forceReactiveUpdate;
    return Boolean(this.client.particularidades && this.client.particularidades.trim().length > 0);
  }

  get editaParticularidades(): boolean {
    return this.settings && this.settings.flagPermiteEditarParticularidades
      ? !this.settings.flagPermiteEditarParticularidades : true;
  }

  get isClientType(): boolean {
    return this.clientType === ClientTypeEnum.Client;
  }

  get isProspectType(): boolean {
    return this.clientType === ClientTypeEnum.Prospect;
  }

  get isOrigemNaoDefinida(): boolean {
    return this.client.origemCadastro === OrigemTypeEnum.SEMORIGEM || this.origemType === null;
  }

  get isOrigemCrm(): boolean {
    return this.client.origemCadastro === OrigemTypeEnum.CRM;
  }

  get isOrigemB2B(): boolean {
    return this.client.origemCadastro === OrigemTypeEnum.B2B;
  }

  get isOrigemForcaVendas(): boolean {
    return this.client.origemCadastro === OrigemTypeEnum.FORCAVENDAS;
  }

  get showTransformProspectBtn(): boolean {
    return this.isProspectType && this.settings?.flagConverteProspectIGS && !this.isConvertedProspect;
  }

  get isProspectOrClientIsIntegrated(): boolean {
    if (this.clientType === ClientTypeEnum.Prospect) return true;
    if (this.clientType === ClientTypeEnum.Client && !this.clientNotIntegrated) return true;
    return false;
  }

  get showIntegrateClient(): boolean {
    return !this.isProspectOrClientIsIntegrated && this.settings.flagIntegracaoClienteUnicoAtivo;
  }

  get allAvailableChips(): IChipParam[] {
    if (!this.client || !this.client.cnpjCpf) {
      return [];
    }

    const availableChips: IChipParam[] = [];

    if (this.client.inadimplente) {
      availableChips.push({
        id: 'defaulting',
        text: `${this.$t('crm.clientDetailsCard.defaulting')} - ${this.client.diasInadimplente}`,
        icon: 'mdi-thumb-down-outline',
        color: 'red',
      });
    }

    if (this.allClientManagements && Array.isArray(this.allClientManagements)) {
      const recentManagements = this.allClientManagements.slice(0, 4);

      recentManagements.forEach((management, index) => {
        let chipText = management.managementName || '';
        if (management.situation) {
          chipText += chipText ? ` (${management.situation})` : management.situation;
        }

        if (chipText) {
          const nomeGestao = management.managementName || 'N/A';
          const situacaoGestao = management.managerSituation || 'N/A';
          const classificacao = management.situation || 'N/A';
          const valorGasto = `R$ ${management.value.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}` || 'N/A';
          const quantidadeCobrada = management.quantity;

          const valorColor = management.managerSituation === ClientManagerSituationEnum.Ativo
            ? '#4caf50'
            : '#f44336';

          const chipHtmlContent = `
            <div style="text-align: left; font-size: 12px;">
                <div style="margin-bottom: 4px;">Classificação:
                  <span style="font-weight: 500;">${classificacao}</span>
                </div>
                <div style="margin-bottom: 4px;">Valor Gasto:
                  <span style="font-weight: 500; color: ${valorColor};">${valorGasto}</span>
                </div>
                <div>Qtd. Comprada: <span style="font-weight: 500;">${quantidadeCobrada}</span></div>
            </div>`;

          const chipColor = management.managerSituation === ClientManagerSituationEnum.Ativo ? 'green' : 'red';

          if (nomeGestao !== 'N/A' || situacaoGestao !== 'N/A') {
            availableChips.push({
              id: `mng-${management.collectionId || index}`,
              text: chipText,
              htmlContent: chipHtmlContent,
              icon: 'mdi-briefcase-check-outline',
              color: chipColor,
            });
          }
        }
      });
    }

    if (this.client.limiteCredito || this.client.limiteCredito === 0) {
      availableChips.push({
        id: 'financial-creditLimit',
        text: `${this.$t('crm.view.financialInformation.card.creditLimit')} -
               ${this.$n(this.client.limiteCredito, 'currency')}`,
        icon: 'mdi-currency-usd',
        color: this.client.limiteCredito < 0 ? 'red' : 'green',
      });
    }

    if (this.client.codGrupoEconomico && this.client.nomeGrupoEconomico) {
      availableChips.push({
        id: 'financial-economicGroup',
        text: `Nome do Grupo - ${this.client.nomeGrupoEconomico}`,
        icon: 'mdi-account-group',
        color: 'green',
      });
    }

    return availableChips;
  }

  get managementChips(): IChipParam[] {
    return this.allAvailableChips.filter((chip) => chip.id.startsWith('mng-'));
  }

  get activeManagementChips(): IChipParam[] {
    return this.managementChips.filter((chip) => chip.color === 'green');
  }

  get inactiveManagementChips(): IChipParam[] {
    return this.managementChips.filter((chip) => chip.color === 'red');
  }

  get otherChips(): IChipParam[] {
    const filtered = this.allAvailableChips.filter(
      (chip) => !chip.id.startsWith('mng-') && !chip.id.startsWith('financial-'),
    );

    return filtered;
  }

  get financialChips(): IChipParam[] {
    const chips: IChipParam[] = [];

    if (this.client.limiteCredito || this.client.limiteCredito === 0) {
      chips.push({
        id: 'financial-creditLimit',
        text: `${this.$t('crm.view.financialInformation.card.creditLimit')} -
               ${this.$n(this.client.limiteCredito, 'currency')}`,
        icon: 'mdi-currency-usd',
        color: this.client.limiteCredito < 0 ? 'red' : 'green',
      });
    }

    if (this.client.codGrupoEconomico && this.client.nomeGrupoEconomico) {
      chips.push({
        id: 'financial-economicGroup',
        text: `Nome do Grupo - ${this.client.nomeGrupoEconomico}`,
        icon: 'mdi-account-group',
        color: 'green',
      });
    }

    return chips;
  }

  get hasPositiveCreditLimit(): boolean {
    return Boolean(this.client.limiteCredito && this.client.limiteCredito > 0);
  }

  get nameInitials(): string {
    return StringHelper.extractInitialsName(this.client.nomeFantasia || this.client.nome).toUpperCase();
  }

  get statusColor(): string {
    switch (this.client.situacao) {
      case ClientStatusEnum.Inactive:
      case ClientStatusEnum.ConversionFailed:
        return colors.red.base;
      case ClientStatusEnum.Converted:
        return '#00dbc6';
      case ClientStatusEnum.Blocked:
        return '#f47304';
      case ClientStatusEnum.Active:
      default:
        return colors.green.base;
    }
  }

  get cnpjCpfMask(): string {
    return this.client.cnpjCpf && this.client.cnpjCpf.length > 11 ? '##.###.###/####-##' : '###.###.###-##';
  }

  get celularMask(): string | null {
    const phone = (this.celular || '').replace(/\D/g, '');
    if (phone.length === 10) {
      return '(##) ####-####';
    }

    if (phone.length === 11) {
      return '(##) #####-####';
    }

    if (phone.length === 13) {
      return '+## (##) #####-####';
    }

    if (phone.length === 14) {
      return '+### (##) #####-####';
    }

    return null;
  }

  get workPhoneMask(): string | null {
    const phone = (this.telefone || '').replace(/\D/g, '');
    if (phone.length === 10) {
      return '(##) ####-####';
    }

    if (phone.length === 11) {
      return '(##) #####-####';
    }

    return null;
  }

  get instagram(): string {
    const instagram = this.client.instagram || '';

    const regexp = new RegExp(
      /((?:(?:http|https):\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/)?([A-Za-z0-9-_.]+)/im,
    );
    const regexpMatch = instagram.match(regexp);
    if (regexpMatch) {
      return regexpMatch[2];
    }

    return instagram;
  }

  get facebook(): string {
    const facebook = this.client.facebook || '';

    const regexp = new RegExp(/((?:(?:http|https):\/\/)?(?:www\.)?(?:facebook\.com)\/)?([A-Za-z0-9-_.]+)/im);
    const regexpMatch = facebook.match(regexp);
    if (regexpMatch) {
      return regexpMatch[2];
    }

    return facebook;
  }

  get instagramUrl(): string {
    return `https://www.instagram.com/${this.instagram}`;
  }

  get facebookUrl(): string {
    return `https://www.facebook.com/${this.facebook}`;
  }

  get isConvertedProspect(): boolean {
    return this.client.situacao === ClientStatusEnum.Converted;
  }

  get forbiddenToSetResponsibleAttendant(): boolean {
    return (this.settings && this.settings.flagPermiteAlterarAtendenteChaveEmMassa === false)
              || this.isConvertedProspect;
  }

  get showRedirectButton(): boolean {
    return (this.client.flagCliente === 1 || this.isConvertedProspect) && this.client.prospectCodCliente != null;
  }

  get nome(): string {
    if (this.mainContactInfo) {
      return this.mainContactInfo.nome;
    }
    if (this.clientType === ClientTypeEnum.Prospect) {
      return this.client.contato || this.client.nomeFantasia || this.client.nome || '';
    }
    return this.client.nome;
  }

  set nome(value: string) {
    if (this.mainContactInfo) {
      this.mainContactInfo.nome = value;
    } else {
      this.client.nome = value;
    }
  }

  get dataDeNascimento(): Date {
    if (this.mainContactInfo) {
      return this.mainContactInfo.dataAniversario;
    }
    return this.client.dataAniversario;
  }

  get telefone(): string {
    if (this.mainContactInfo) {
      return this.mainContactInfo.telefone;
    }
    return this.client.telefone || '';
  }

  set telefone(value: string) {
    if (this.mainContactInfo) {
      this.mainContactInfo.telefone = value;
    } else {
      this.client.telefone = value;
    }
  }

  get celular(): string {
    if (this.mainContactInfo) {
      return this.mainContactInfo.whatsapp || '';
    }
    return this.client.celular || '';
  }

  set celular(value: string) {
    if (this.mainContactInfo) {
      this.mainContactInfo.whatsapp = value;
    } else {
      this.client.celular = value;
    }
  }

  get email(): string {
    if (this.mainContactInfo) {
      return this.mainContactInfo.email || '';
    }
    return this.client.email || '';
  }

  set email(value: string) {
    if (this.mainContactInfo) {
      this.mainContactInfo.email = value;
    } else {
      this.client.email = value;
    }
  }

  get cargos(): string {
    if (this.mainContactInfo) {
      return this.mainContactInfo.tiposContato?.map((item: ContactTypeModel) => item.descricao).join(', ') || '';
    }
    return '';
  }

  set cargos(value: string) {
    if (this.mainContactInfo) {
      this.mainContactInfo.tiposContato = value.split(', ').map((descricao) => ({ descricao } as ContactTypeModel));
    }
  }

  get isAddressEmpty(): boolean {
    return !this.client.cidade
           && !this.client.endBairro
           && !this.client.endRua
           && !this.client.endNumero
           && !this.client.endComplemento
           && !this.client.endCEP;
  }

  get hasAdditionalInfo(): boolean {
    return this.hasCreditLimit || this.hasEconomicGroup || this.isProspectOrClientIsIntegrated;
  }

  get hasCreditLimit(): boolean {
    return this.client.limiteCredito !== null && this.client.limiteCredito !== undefined;
  }

  get creditLimitColor(): string {
    if (!this.hasCreditLimit) return 'grey';
    return (this.client.limiteCredito || 0) < 0 ? 'red' : 'green';
  }

  get creditLimitValueColor(): string {
    if (!this.hasCreditLimit) return '#666';
    return (this.client.limiteCredito || 0) < 0 ? '#f44336' : '#4caf50';
  }

  get creditLimitStatus(): string {
    if (!this.hasCreditLimit) return 'N/A';
    return this.client.limiteCredito && this.client.limiteCredito > 0 ? 'POSITIVO' : 'LIMITADO';
  }

  get hasEconomicGroup(): boolean {
    return Boolean(this.client.codGrupoEconomico && this.client.nomeGrupoEconomico);
  }

  get economicGroupColor(): string {
    return this.hasEconomicGroup ? 'green' : 'grey';
  }

  get additionalInfoItemsCount(): number {
    let count = 0;
    if (this.hasCreditLimit) count += 1;
    if (this.hasEconomicGroup) count += 1;
    if (this.isProspectOrClientIsIntegrated) count += 1;
    return count;
  }

  get isSocialEmpty(): boolean {
    return !this.client.instagram && !this.client.facebook;
  }

  get isExtraInfoEmpty(): boolean {
    return !this.client.lead
            && !this.client.inscEstadual
            && !this.client.suframa
            && !this.client.origemCadastro
            && !this.client.observacao
            && !this.client.formaCaptacao;
  }

  private async initializeUserContext(): Promise<void> {
    if (!this.userContactInfo && this.contactService) {
      try {
        this.localUserContactInfo = await this.contactService.getLoggedUserContactInfo();
      } catch (err) {
        console.warn('Não foi possível obter informações do usuário:', err);
      }
    }
  }

  private async loadExpandirParticularidadeConfig(): Promise<void> {
    const currentUser = this.currentUserContactInfo;
    if (!currentUser?.id) {
      this.loadExpandirParticularidadeConfigFromLocalStorage();
      return;
    }

    try {
      const response = await this.configUsuarioService.getExpandirParticularidadeStatus(currentUser.id);
      this.expandParticularitiesToDefault = response.expandirPorPadrao;

      if (this.expandParticularitiesToDefault) {
        this.particularitiesExpanded = true;
      }

      CrmClientDetailsCard.saveExpandirParticularidadeConfigToLocalStorage(this.expandParticularitiesToDefault);
    } catch (err) {
      this.expandParticularitiesToDefault = false;
      this.loadExpandirParticularidadeConfigFromLocalStorage();
    }
  }

  private loadExpandirParticularidadeConfigFromLocalStorage(): void {
    try {
      const saved = localStorage.getItem('geovendas-expandir-particularidades');
      if (saved !== null) {
        this.expandParticularitiesToDefault = JSON.parse(saved);
        if (this.expandParticularitiesToDefault) {
          this.particularitiesExpanded = true;
        }
      }
    } catch (err) {
      console.warn('Erro ao carregar configuração do localStorage:', err);
    }
  }

  private static saveExpandirParticularidadeConfigToLocalStorage(value: boolean): void {
    try {
      localStorage.setItem('geovendas-expandir-particularidades', JSON.stringify(value));
    } catch (err) {
      console.warn('Erro ao salvar configuração no localStorage:', err);
    }
  }

  async onExpandParticularitiesToDefaultChange(): Promise<void> {
    const currentUser = this.currentUserContactInfo;

    if (this.isCheckboxDisabled) {
      if (this.isChangingConfig) {
        this.$notify.warn(this.$t('crm.clientDetailsCard.messages.tooManyRequests'));
      } else {
        const message = this.$t('crm.clientDetailsCard.messages.waitToChangeConfig').toString()
          .replace('5', this.remainingCooldownTime.toString());
        this.$notify.warn(message);
      }

      this.$nextTick(() => {
        this.expandParticularitiesToDefault = !this.expandParticularitiesToDefault;
      });
      return;
    }

    this.isChangingConfig = true;
    this.lastConfigChangeTime = Date.now();
    this.startCooldownTimer();

    try {
      CrmClientDetailsCard.saveExpandirParticularidadeConfigToLocalStorage(this.expandParticularitiesToDefault);

      if (currentUser?.id) {
        await this.configUsuarioService.saveExpandirParticularidadePorPadrao({
          usuarioId: currentUser.id,
          expandirPorPadrao: this.expandParticularitiesToDefault,
        });

        this.$notify.success(this.$t('crm.clientDetailsCard.messages.configSaved'));
      } else {
        this.$notify.success('Configuração salva localmente');
      }

      if (this.expandParticularitiesToDefault) {
        this.particularitiesExpanded = true;
      }
    } catch (err) {
      this.$notify.error(this.$t('crm.clientDetailsCard.messages.errorSavingConfig'));

      this.expandParticularitiesToDefault = !this.expandParticularitiesToDefault;
      this.stopCooldownTimer();
    } finally {
      this.isChangingConfig = false;
    }
  }
}
